export async function getIPMPingCount() {
    const storage = await browser.storage.local.get("total_ipm_pings");
    const count = storage.total_ipm_pings;
    return typeof count === "number" && !Number.isNaN(count) ? count : 0;
}
